export default "__VITE_ASSET__BfTWssAG__"